import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MarketShell from '../components/market/MarketShell';
import { myInquiries } from '../lib/marketInquiries';
import { PinnedProduct } from './MarketInquiry';

// The trader's questions to suppliers (/market/inquiries), newest first, with unread answers.
const T = {
  ar: { title: 'أسئلتي للموردين', none: 'لم تسأل أي مورد بعد. افتح منتجًا واضغط «اسأل المورد».', unread: (n) => `${n} ردّ جديد`, waiting: 'بانتظار ردّ المورد', signin: 'سجّل الدخول لعرض أسئلتك.' },
  en: { title: 'My questions to suppliers', none: 'You have not asked a supplier yet. Open a product and tap "Ask the supplier".', unread: (n) => `${n} new`, waiting: 'Waiting for the supplier', signin: 'Sign in to see your questions.' },
  zh: { title: '我向供应商的提问', none: '您还没有提问。打开产品并点击“询问供应商”。', unread: (n) => `${n} 条新回复`, waiting: '等待供应商回复', signin: '登录后查看您的提问。' },
};

export default function MarketInquiries(props) {
  const { lang = 'ar', user } = props;
  const t = T[lang] || T.ar;
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { if (user) myInquiries().then((r) => setRows(r.ok ? r.data || [] : [])); }, [user]);
  return (
    <MarketShell {...props}>
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '16px' }}>
        <h1 style={{ fontSize: 20, margin: '0 0 12px' }}>{t.title}</h1>
        {!user ? <p>{t.signin}</p> : rows == null ? <p>…</p> : rows.length === 0 ? <p data-inquiries-empty="1" style={{ color: 'var(--text-secondary)' }}>{t.none}</p> : rows.map((r) => (
          <div key={r.id} data-inquiry-row={r.id} onClick={() => nav(`/market/inquiries/${r.id}`)} style={{ cursor: 'pointer', marginBottom: 12 }}>
            <PinnedProduct pr={r.product_ref || {}} lang={lang} onOpen={() => nav(`/market/inquiries/${r.id}`)} />
            <div style={{ display: 'flex', gap: 8, fontSize: 12.5, color: 'var(--text-secondary)', padding: '0 4px' }}>
              <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.last}</span>
              {r.unread > 0 ? <b style={{ color: '#9A7636' }}>{t.unread(r.unread)}</b> : r.status === 'open' ? <span>{t.waiting}</span> : null}
            </div>
          </div>
        ))}
      </div>
    </MarketShell>
  );
}
